import Articles from "components/Articles";
import { WideContainer } from "components/Container";
import Footer from "components/Footer";
import Main from "components/Main";
import Navigation from "components/Navigation";
import i18n from "i18next";
import { GetStaticPropsContext } from "next";
import Head from "next/head";
import FeaturedArticle from "pages/blog/components/FeaturedArticle";
import { client } from "prismic-configuration";
import Prismic from "prismic-javascript";
import { Document } from "@prismicio/client/types/documents";
import React from "react";

export async function getStaticProps({ preview = false }: GetStaticPropsContext) {
  const { results: articles } = await client.query(Prismic.Predicates.at("document.type", "article"), {
    lang: "en-us",
    orderings: "[my.article.date desc]",
    fetchLinks: ["author.name", "author.photo"],
  });

  return {
    props: { articles, preview },
  };
}

export default function Blog({ articles }: { articles: Document[] }) {
  return (
    <>
      <Head>
        <title>{i18n.t("Blog")} - Bjarn Bronsveld</title>
        <meta property="og:title" content={`${i18n.t("Blog")} - Bjarn Bronsveld`} key="og_title" />
        <meta name="twitter:title" content={`${i18n.t("Blog")} - Bjarn Bronsveld`} key="twitter_title" />
      </Head>

      <Navigation />

      <Main className="flex flex-col flex-1 pt-20">
        <WideContainer>
          <FeaturedArticle article={articles[0]} />
          <div className="mt-8">
            <h1 className="pt-4 pb-2 text-3xl font-bold">{i18n.t("Blog")}.</h1>
          </div>
          <div className="mt-4">
            <Articles articles={articles} />
          </div>
        </WideContainer>
      </Main>
      <div className="mt-32">
        <Footer />
      </div>
    </>
  );
}
